import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Property } from '../../../models/property.model';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatHint, MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-display-name-edit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormField,
    MatInputModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatHint,
    FormsModule
],
  templateUrl: './display-name-edit.html',
  styleUrl: './display-name-edit.scss',
})
export class DisplayNameEdit {
  @Input() dialogRef?: MatDialogRef<any>;  // Optional: direct close
  readonly data = inject<Property>(MAT_DIALOG_DATA);
  displayName = '';

  @Output()
  private _save = new EventEmitter<string>();

  public get save() {
    return this._save;
  }
  public set save(value) {
    this._save = value;
  }

  @Output() cancel = new EventEmitter<void>();
}
